const viMessages = {
  /* 01.General */
  "chat.end": "Khởi động lại cuộc trò chuyện của bạn",
  "chat.endall": "Kết thúc trò chuyện",
  "chat.cancel": "Hủy bỏ",
  "chat.cookie":
    "Trợ lý kỹ thuật số này sử dụng cookie để đảm bảo bạn có được trải nghiệm tốt nhất",
  "chat.learn": "Tìm hiểu thêm",
  "chat.minimize": "Giảm thiểu",
  "chat.hide": "Đóng",
  "chat.hidebot.text": "Đóng sẽ làm cho hình đại diện biến mất trong 15 phút",
  "chat.hidebot": "Đóng Bot",
  "chat.restart": "Khởi động lại",
  "switch.language": "Chuyển đổi ngôn ngữ",
  "switch.property": "Chuyển đổi thuộc tính",
  "restart.converstation": "Khởi động lại hội thoại",
  "chat.endtext":
    "Bạn có chắc chắn muốn kết thúc cuộc trò chuyện hiện tại không?",
  "check.availabity": "Sẵn sàng kiểm tra",
  "check.availabity.submit": "Nộp",
  "check.availabity.cancel": "Hủy bỏ",
  "check.availabity.adults": "Người lớn ",
  "check.availabity.children": "Bọn trẻ",
  "check.availabity.child.age": "Tuổi - Trẻ em",
  "feedback.leave": "Để lại phản hồi",
  "feedback.leave.message": "Để lại tin nhắn",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Gửi yêu cầu",
  "caseform.system": "Hệ thống",
  "caseform.loading.systems": "Đang tải hệ thống...",
  "caseform.select.system": "Chọn hệ thống",
  "caseform.error.systems": "Lỗi tải hệ thống",
  "caseform.scenario": "Kịch bản",
  "caseform.loading.scenarios": "Đang tải kịch bản...",
  "caseform.select.scenario": "Chọn kịch bản",
  "caseform.error.scenarios": "Lỗi tải kịch bản",
  "caseform.topic": "Chủ đề",
  "caseform.loading.topics": "Đang tải chủ đề...",
  "caseform.select.topic": "Chọn chủ đề",
  "caseform.error.topics": "Lỗi tải chủ đề",
  "caseform.subject": "Chủ đề",
  "caseform.description": "Mô tả",
  "caseform.submit": "Gửi",
  "caseform.cancel": "Hủy",
  "caseform.success.title": "Đã tạo yêu cầu",
  "caseform.success.message": "Yêu cầu của bạn đã được tạo thành công.",
  "caseform.success.caseNumber": "Mã yêu cầu:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Chọn một hành động",
  "simpleaction.body":
    "Vui lòng chọn một trong các tùy chọn sau:{br}{b}Tạo yêu cầu{/b} để gửi yêu cầu hỗ trợ, hoặc {b}Bắt đầu trò chuyện{/b} để kết nối với đại lý ngay bây giờ.",
  "simpleaction.startchat": "Bắt đầu trò chuyện",
  "simpleaction.createcase": "Tạo yêu cầu",
  "caseform.error.generic": "Lỗi khi tạo yêu cầu.",
  "caseform.error.generic.message":
    "Đã xảy ra lỗi khi tạo yêu cầu của bạn. Vui lòng thử lại sau.",
};
export default viMessages;
